import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setQuestion, setAllQuestion, setRegister } from "features/RegisterKlSlice";
import _ from "lodash";
import { Controller, useForm } from "react-hook-form";
import helper from "services/helper";
import {
  QuestionnaireSearch,
  CreateTransactionCustomer,
  UpdateTransactionCustomer,
} from "services/Api/Module/Customer";
import ModalContext from "contexts/ModalContext";
import { setProfile } from "features/ProfileSlice";

const Question = () => {
  const stateQuestion = useSelector((state) => state.registerKl.answerQuestion);
  const stateAllQuestion = useSelector((state) => state.registerKl.allQuestion);
  const stateCustomer = useSelector((state) => state.registerKl.customerData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mAlert } = useContext(ModalContext);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disable, setDisable] = useState(true);

  const setCustomerId = (id) => {
    dispatch(setProfile({ customerId: id }));
  };

  const payloadDataCreateCustomer = () => {
    const {
      address, birthDate, firstName, genderId,
      isConsentNewsAndPromotion, isConsentPDPA, isConsentTAndC,
      lastName, mobileNo, postcode, subDistrict, themeSelected,
      lineImageUrl, lineUid, lineName, referenceId,
    } = stateCustomer;

    const convertTheme = 3;
    const pointType = 1;
    const status = 1;
    const _stateAllQuestion = [...stateAllQuestion];
    const _stateAnswerQuestion = { ...stateQuestion };
    let prepareQuestionnaire = new Array();

    let isEmpty = Object.keys(_stateAnswerQuestion).length === 0;
    if (!isEmpty) {
      prepareQuestionnaire = _stateAllQuestion.map((item) => ({
        questionnaireMain: item.questionmain,
        questionnaireList: stateQuestion[item.questionmain],
      }));
    }

    return {
      lineUid, lineName, pProfileImgUrl: lineImageUrl,
      firstName, lastName, mobileNo, birthDate, genderId, address,
      referenceId: referenceId ? referenceId : null,
      themeSelected: convertTheme, isRegisSbSystem: true,
      subDistrict, postcode,
      isConsentPdpa: isConsentPDPA, isConsentTandc: isConsentTAndC,
      isConsentNewsAndPromotion, pointType, status,
      customerQuestionniare: prepareQuestionnaire,
    };
  };

  const payloadDataUpdateCustomer = () => {
    const {
      customerId, address, firstName, genderId,
      isConsentNewsAndPromotion, isConsentPDPA, isConsentTAndC,
      lastName, mobileNo, birthDate, postcode, referenceId,
      subDistrict, themeSelected, lineImageUrl, lineUid, lineName,
    } = stateCustomer;

    const convertTheme = 3;
    const pointType = 1;
    const status = 1;
    const _stateAllQuestion = [...stateAllQuestion];
    const _stateAnswerQuestion = { ...stateQuestion };
    let prepareQuestionnaire = new Array();

    let isEmpty = Object.keys(_stateAnswerQuestion).length === 0;
    if (!isEmpty) {
      prepareQuestionnaire = _stateAllQuestion.map((item) => ({
        questionnaireMain: item.questionmain,
        questionnaireList: stateQuestion[item.questionmain],
      }));
    }

    return {
      customerId, lineUid, lineName, pProfileImgUrl: lineImageUrl,
      firstName, lastName, mobileNo, birthDate, genderId, address,
      referenceId, themeSelected: convertTheme, isRegisSbSystem: true,
      subDistrict, postcode,
      isConsentPdpa: isConsentPDPA, isConsentTandc: isConsentTAndC,
      isConsentNewsAndPromotion, pointType, status,
      customerQuestionniare: prepareQuestionnaire,
    };
  };

  const createNewCustomer = async (payload) => {
    let _return = { status: false, result: null };
    try {
      const { data } = await CreateTransactionCustomer({ data: payload });
      if (data.resultCode === "20000") {
        _return.status = true;
        _return.result = data.resultData;
      } else {
        mAlert.info({
          open: true,
          title: "เกิดข้อผิดพลาด",
          subTitle: "กรุณาลองใหม่อีกครั้ง",
          content: "",
          onExit: () => navigate("/register"),
        });
      }
    } catch (e) {
      mAlert.info({
        open: true,
        title: "เกิดข้อผิดพลาด",
        subTitle: "กรุณาลองใหม่อีกครั้ง",
        content: "",
        onExit: () => navigate("/question"),
      });
      setIsLoading(false);
      console.log("ERR :", e);
    }
    return _return;
  };

  const updateCustomer = async (id, payload) => {
    let _return = { status: false, result: null };
    try {
      const { data } = await UpdateTransactionCustomer({ id, data: payload });
      if (data.resultCode === "20000") {
        _return.status = true;
        _return.result = data.resultData;
      } else {
        mAlert.info({
          open: true,
          title: "เกิดข้อผิดพลาด",
          subTitle: "กรุณาลองใหม่อีกครั้ง",
          content: "",
          onExit: () => navigate("/register"),
        });
      }
    } catch (e) {
      mAlert.info({
        open: true,
        title: "เกิดข้อผิดพลาด",
        subTitle: "กรุณาลองใหม่อีกครั้ง",
        content: "",
        onExit: () => navigate("/question"),
      });
      setIsLoading(false);
      console.log("ERR :", e);
    }
    return _return;
  };

  const createCustomerTransaction = async (payload) => {
    const result = await createNewCustomer(payload);
    if (result.status) {
      setCustomerId(result.result.id);
      navigate("/success");
    }
    return result;
  };

  const updateCustomerTransaction = async (id, payload) => {
    const result = await updateCustomer(id, payload);
    if (result.status) {
      setCustomerId(result.result.id);
      navigate("/success");
    }
    return result;
  };

  const onSubmit = () => {
    setIsSubmit(true);
    setIsLoading(true);
    const condition = stateCustomer.customerId ? true : false;
    try {
      if (!condition) {
        const payloadCreateData = payloadDataCreateCustomer();
        createCustomerTransaction(payloadCreateData);
      } else if (condition) {
        const payloadUpdateData = payloadDataUpdateCustomer();
        updateCustomerTransaction(stateCustomer.customerId, payloadUpdateData);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("ERR :", error);
    }
  };

  const validateForm = () => {
    if (Object.keys(stateQuestion).length !== 3) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  };

  useEffect(() => {
    validateForm();
  }, [stateQuestion]);

  const {
    control,
    watch,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
    getFieldState,
    register,
  } = useForm();

  const getQuestionnaireSearch = async () => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await QuestionnaireSearch();
      if (data.resultCode === "20000") {
        const resData = data.resultData;

        _return.status = true;
        _return.result = resData;
      }
    } catch (err) {
      console.log("ERR :", err);
    }

    return _return;
  };

  useEffect(() => {
    (async () => {
      const questionnaireData = await getQuestionnaireSearch();
      if (questionnaireData) {
        dispatch(setAllQuestion(questionnaireData.result));
      }
    })();
  }, []);

  const setCheck = (mainId, listId, state) => {
    if (state[mainId] && state[mainId].includes(listId)) {
      return true;
    }
    return false;
  };

  return (
    <div>
      <Helmet>
        <title>โคอะลา มาร์ช</title>
        <meta name="title" content="โคอะลา มาร์ช" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="โคอะลา มาร์ช" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="" />
      </Helmet>

      {/* <!-- Content Page --> */}

      <div id="pageRegister-step2">
        {/* <!-- Content Page --> */}

        <main>
          <div className="wrapContent">
            <section id="pServayMain">
              <div className="bServay">
                <div className="bTitlePage">
                  <h1>แบบสอบถาม</h1>
                  <p>ตอบคำถามกับเราสักหน่อย เพื่อให้เราได้เข้าใจคุณมากขึ้น</p>
                </div>
                {stateAllQuestion && (
                  <div className="bForm">
                    {stateAllQuestion.map((item0) => {
                      return (
                        <div className="bGroup">
                          <div
                            className={`control-group ${
                              errors.mainQ1 ? "error" : ""
                            }`}
                          >
                            <div key={item0.id} className="bQuestion">
                              {item0.name}
                            </div>

                            <div className="bAnswer">
                              <div className="control-group">
                                <p className="" style={{ color: "gray" }}>
                                  ตอบได้มากกว่า 1 ข้อ
                                </p>
                                {item0.questionnaireList.map((item1) => (
                                  <label className="control control--checkbox">
                                    <p>{item1.name}</p>

                                    <input
                                      name={`mainQ.${item1.id}`}
                                      key={item1.id}
                                      checked={setCheck(
                                        item0.questionmain,
                                        item1.id,
                                        stateQuestion
                                      )}
                                      type="checkbox"
                                      onChange={(e) => {
                                        const _answerQuestion =
                                          helper.FNFORM.handleCheckBox(
                                            item0.questionmain,
                                            item1.id,
                                            stateQuestion
                                          );

                                        dispatch(setQuestion(_answerQuestion));
                                      }}
                                    />
                                    <div className="control__indicator"></div>
                                  </label>
                                ))}
                              </div>
                            </div>
                          </div>
                          {/* { Object.keys(allQuestion).length ? '': <p className="">เลือกอย่างน้อย 1 ข้อ</p>} */}
                          {isSubmit &&
                          stateQuestion[item0.questionmain] === undefined ? (
                            <p className="" style={{ color: "red" }}>
                              ตอบได้มากกว่า 1 ข้อ
                            </p>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                <div className="bStepBtn">
                  <div className="bStep">
                    <div className="bBullet">
                      <i></i>
                      <i></i>
                      <i></i>
                      <i></i>
                    </div>
                    <p>เหลืออีกเพียงขั้นตอนเดียวก็จะเสร็จสิ้นการลงทะเบียน</p>
                  </div>
                  <div className="bBtn">
                    <button
                      className="btn"
                      onClick={onSubmit}
                      disabled={isLoading}
                    >
                      ยืนยัน
                    </button>
                    <button
                      className="btn outline"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      ย้อนกลับ
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Question;
